import { type FC } from "react";
import PackageCard from "./PackageCard";
import { PackageChildren } from "./PackageChildren";
import type { PackageFamily } from "./PackagesList";

export interface Props {
  readonly family: PackageFamily;
  readonly onClick: (id: string) => void;
  readonly onContextMenu: (id: string) => void;
  readonly isFirst: boolean;
  readonly isLast: boolean;
  readonly onMovePackage: (id: string, direction: "up" | "down") => void;
}

export const PackageNode: FC<Props> = ({ family, onClick, onContextMenu, isFirst, isLast, onMovePackage }) => (
  <>
    <PackageCard
      value={{
        ...family.root,
        name: family.root.name.value,
        notes: family.root.notes ?? [],
      }}
      onClick={onClick}
      onContextMenu={onContextMenu}
      isFirst={isFirst}
      isLast={isLast}
      onMoveUp={() => onMovePackage(family.root.id.id, "up")}
      onMoveDown={() => onMovePackage(family.root.id.id, "down")}
    />

    <PackageChildren
      packages={family.children}
      onClick={onClick}
      onContextMenu={onContextMenu}
      onMovePackage={onMovePackage}
    />
  </>
);
